import { default as getTopLevelParent } from '../getTopLevelParent';

export default (state, mid) => getTopLevelParent(state, mid).s_id == 'CITVOICE';
